import classnames from 'classnames/bind'

// Types
import type { CategoryPreferenceOption } from '@/api/fetchCategoryPreference'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// 沒有封面圖的分類用這幾組柔和漸層輪流當底
const FALLBACK_TONES = 4

type PropTypes = {
  options: CategoryPreferenceOption[]
  value: number[]
  onChange: (value: number[]) => void
}

// 偏好分類選擇：第二層分類是可複選的圖片卡（封面是該分類目前最熱門的商品）
const CategoryPreferencePicker = ({ options, value, onChange }: PropTypes) => {
  const selected = new Set(value)

  const toggle = (id: number) => {
    onChange(selected.has(id) ? value.filter((v) => v !== id) : [...value, id])
  }

  // 全部第二層排成同一個格狀，大類名稱放在卡片上當小標（每個大類只有兩三個，分組換行會留下一大片空白）
  const tiles = options.flatMap((group) => (group.children ?? []).map((option) => ({ ...option, groupName: group.name })))

  return (
    <div className={cx('category-preference')}>
      {tiles.map((option, index) => {
        const isActive = selected.has(option.id)

        return (
          <button
            key={option.id}
            type='button'
            aria-pressed={isActive}
            className={cx('category-preference__tile', `category-preference__tile--tone-${index % FALLBACK_TONES}`, {
              'category-preference__tile--active': isActive,
              'category-preference__tile--no-image': !option.image,
            })}
            onClick={() => toggle(option.id)}
          >
            {option.image && (
              // 商品圖網域不一定在 next/image 的白名單（各環境不同），用一般 img 就好
              // eslint-disable-next-line @next/next/no-img-element
              <img className={cx('category-preference__tile-image')} src={option.image} alt='' loading='lazy' decoding='async' />
            )}
            <span className={cx('category-preference__tile-text')}>
              <span className={cx('category-preference__tile-group')}>{option.groupName}</span>
              <span className={cx('category-preference__tile-name')}>{option.name}</span>
            </span>
            <span className={cx('category-preference__tile-check')} aria-hidden>
              <svg viewBox='0 0 16 16' width='12' height='12'>
                <path d='M3.5 8.5l3 3 6-7' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default CategoryPreferencePicker
